module.exports = __webpack_public_path__ + "img/p7.e2a261db.png";